module.exports = __webpack_public_path__ + "static/media/rubirosa.5e25eec2.jpg";